export class Alerts {
    constructor() {
      this.timeout = 30000;
      this.type = "alert";
      this.instances = []
    }
  
    create(message, pos, type, timeout,title) {
        var create = true;
        for(var i = 0; i < this.instances.length;i++){
            if(message == this.instances[i].text){
                this.instances[i].count += 1
                this.instances[i].instance.setTimeout(this.timeout);
                var htmlEl = `<span class=""> <b class="noti-abs left">x${this.instances[i].count}  </b> <span> ${this.instances[i].text}</span></span>`;
                this.instances[i].instance.setText(htmlEl)
                clearTimeout(this.instances[i].time);
                this.instances[i].time = setTimeout(()=>{
                    this.instances.shift();
                },this.timeout);
                create = false;
            }
        }
        if(create){
            var noti = new Noty({
                type: type || this.type,
                text: message || '',
                timeout: timeout || this.timeout,
                theme: 'nest',
                layout: pos
            }).show();
            
            
            var timeout = setTimeout(()=>{
                this.instances.shift();
            },this.timeout)
            this.instances.push({
                text: message,
                count: 1,
                instance: noti,
                time: timeout 
            })
        }
    }
    info(message, pos = 'topRight',haptic = true, timeout,title) {
        if(typeof title == "undefined"){
            var title = "Информация:";
        }

        return this.create(`<span class="left">${message}</span>`,pos, "info", timeout);
    }

    success(message, pos = 'topRight',haptic = true, timeout,title) {
        if(typeof title == "undefined"){
            var title = "Информация:"; 
        }
        if(haptic){
            window.Telegram.WebApp.HapticFeedback.notificationOccurred('success');
        }
        
        return this.create(`<span class="left">${message}</span>`,pos, "success", timeout);
    }

    warning(message, pos = 'topRight',haptic = true, timeout,title) {
        if(typeof title == "undefined"){
            var title = "Информация:"; 
        }
        if(haptic){
            window.Telegram.WebApp.HapticFeedback.notificationOccurred('warning');
        }
        
        
        return this.create(`<span class="left">${message}</span>`,pos, "warning", timeout);
    }
    message(message, pos = 'topRight', timeout,title) {
        if(typeof title == "undefined"){
            var title = "Информация:"; 
        }
        
        return this.create(`<span class="left">${message}</span>`,pos, "message", 7777);
    }

    error(message, pos = 'topRight',haptic = true, timeout,title) {
        if(typeof title == "undefined"){
            var title = "Информация:"; 
        }
        if(haptic){
            window.Telegram.WebApp.HapticFeedback.notificationOccurred('error');
        }
        
        
        return this.create(`<span class="left">${message}</span>`,pos, "error", timeout);
    }
  }

